export enum PostProductionInspectionTaskItemStatusCode {
    Pass = 0,
    Fail = 1,
    NA = 2,
}

